// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"157":"f6157382","165":"0af1c619","664":"467fbd6e","675":"d8c6605b"}[chunkId] + ".chunk.js";
};